import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const blockSlice = createSlice({
    name: 'block',
    initialState: {
        blockedUsers: {}, // { userId: true/false }
    },
    reducers: {
        setBlockStatus: (state, action) => {
            const { userId, isBlocked } = action.payload;
            state.blockedUsers[userId] = isBlocked;
        },
    },
});

export const { setBlockStatus } = blockSlice.actions;

// ✅ Block User Function - Redux Thunk
export const blockUser = (networkId) => async (dispatch) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            '/api/applicant/messages/block-user',
            { networkId },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        
        // Redux state update
        dispatch(setBlockStatus({ userId: networkId, isBlocked: true }));
        
        return { success: true, message: response.data.message };
    } catch (error) {
        console.error('Error blocking user:', error);
        return { success: false, error: error.message };
    }
};

// ✅ Unblock User Function - Redux Thunk
export const unblockUser = (networkId) => async (dispatch) => {
    try {
        const token = localStorage.getItem('token');
        const response = await axios.post(
            '/api/applicant/messages/unblock-user',
            { networkId },
            { headers: { Authorization: `Bearer ${token}` } }
        );
        
        // Redux state update
        dispatch(setBlockStatus({ userId: networkId, isBlocked: false }));
        
        return { success: true, message: response.data.message };
    } catch (error) {
        console.error('Error unblocking user:', error);
        return { success: false, error: error.message };
    }
};

export default blockSlice.reducer;